import { authenticatedApi, publicApi } from "./api";
import IBeneficiary from "../models/beneficiary";
import IContract from "../models/contract";

interface LoginBeneficiaryContractResponse {
  access_token: string;
  contract: IContract;
}

interface BeneficiaryMeResponse {
  contract: IContract;
  beneficiary: IBeneficiary;
}

interface SendForgotCredentialsResponse {
  success: boolean;
  message: string;
}

export const authApi = {
  loginBeneficiaryContract: async (
    firstName: string,
    lastName: string,
    contractNumber: string
  ): Promise<LoginBeneficiaryContractResponse> => {
    const response = await publicApi.post("/auth/login/beneficiary/contract", {
      firstName,
      lastName,
      contractNumber,
    });
    return response.data;
  },

  getBeneficiaryMe: async (): Promise<BeneficiaryMeResponse> => {
    const response = await authenticatedApi.get("/auth/beneficiary/me");
    return response.data;
  },

  sendForgotCredentials: async (
    registration: string
  ): Promise<SendForgotCredentialsResponse> => {
    const response = await publicApi.post("/contracts/send-credentials-by-registration", {
      registration,
    });
    return response.data;
  },
};